import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import UnitechHeader from "../image/header.png";
import UnitechFooter from "../image/footer.png";

let config = {
  margin: 15,
  borderMagin: 7,
  headerHeight: 60,
  footerHeight: 60,
  fontSize: 10,
  bordergap: 5,
  currentY: 0,
  letterHead: true,
};

// Helper function to draw the header and footer images
 function addHeaderFooter(doc,totalWidth) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  
  if(config.letterHead){
    doc.addImage(UnitechHeader, "PNG", 0, 0, pageWidth, config?.headerHeight);
  }
  drawSignatureTable(doc, totalWidth, pageHeight - config?.footerHeight - 45)
  if(config.letterHead){
    doc.addImage(
      UnitechFooter,
      "PNG",
      0,
      pageHeight - config?.footerHeight,
      pageWidth,
      config?.footerHeight
    );
  }
}

function drawSignatureTable(doc, totalWidth, startY) {
  doc.autoTable({
    margin: { left: config.borderMagin, right: config.borderMagin },
    startY,
    body: [
      [
        {
          content: "Calibrated By  |",
          styles: { fontStyle: "bold", halign: "left" },
        },
        {
          content: "Verified By  |",
          styles: { fontStyle: "bold", halign: "left" },
        },
      ],
      [
        {
          content: "Prepared By :                                                        QM",
          styles: { fontStyle: "bold", halign: "left" },
        },
        {
          content:
            "Approved and Issued By :                                    MD & TM",
          styles: { fontStyle: "bold", halign: "left" },
        },
      ],
    ],
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 4,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [217, 217, 217],
      textColor: 0,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },
    bodyStyles: {
      halign: "left",
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: (totalWidth - config?.borderMagin * 2) / 2 },
      1: { cellWidth: (totalWidth - config?.borderMagin * 2) / 2 },
    },
  });
}

function drawCheckListTable(
  doc,
  drawMarginRect,
  checkPointData,
  letterHead,
  standardDetails,
  client,
  addressData,
  totalWidth
) {
  let startY = config.headerHeight + config.margin + 15;
  const boxWidth = doc.internal.pageSize.getWidth() - config.margin * 2;

  doc.setFont("helvetica", "normal");

  doc.autoTable({
    margin: { left: config.margin, right: config.margin },
    startY,
    body: [["CHECK LIST FOR ONSITE CALIBRATION"]],
    theme: "grid",
    styles: {
      fontSize: 14,
      fontStyle: "bold",
      halign: "center",
      cellPadding: 6,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    columnStyles: {
      0: { cellWidth: boxWidth },
    },
  });

  startY = doc.lastAutoTable.finalY + 5;

  doc.autoTable({
    margin: { left: config.margin, right: config.margin },
    startY,
    body: [
      [
        { content: "", styles: { fontStyle: "bold" } },
        {
          content: "Customer Details",
          colSpan: 3,
          styles: {
            halign: "center",
            valign: "middle",
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
        },
      ],
      [
        { content: "SRF NO:", styles: { fontStyle: "bold" } },
        { content: standardDetails?.srfNo },
        { content: "Date:", styles: { fontStyle: "bold" } },
        {
          content: standardDetails?.outwardDate
            ? moment(standardDetails.outwardDate).format("DD-MM-YYYY")
            : "",
        },
      ],
      [
        "1",
        { content: "Customer Name & Address", styles: { minCellHeight: 20 } },
        {
          content: `${client?.companyName} \n${addressData?.address}`,
          colSpan: 2,
        },
        "",
      ],
      [
        {
          content: "Job Details",
          colSpan: 4,
          styles: {
            halign: "center",
            valign: "middle",
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
        },
      ],
    ],
    theme: "grid",
    styles: {
      fontSize: 10,
      halign: "left",
      valign: "middle",
      cellPadding: 6,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    columnStyles: {
      0: { cellWidth: 60 },
      1: { cellWidth: boxWidth / 2 - 60 },
      2: { cellWidth: 50 },
      3: { cellWidth: boxWidth / 2 - 50 },
    },
  });

  startY = doc.lastAutoTable.finalY;

  const tableColumn = ["S.No", "Documents", "Yes", "No"];
  const tableRows = [];

  checkPointData.forEach((item, index) => {
    tableRows.push([
      index + 2,
      item.label,
      {
        content: item.value ? "Yes" : "",
        styles: { halign: "center", valign: "middle", font: "helvetica" },
      },
      {
        content: item.value ? "" : "No",
        styles: { halign: "center", valign: "middle", font: "helvetica" },
      },
    ]);

    if (index === 5) {
      tableRows.push([
        {
          content: "Tools/Accessories",
          colSpan: 4,
          styles: {
            halign: "center",
            fontStyle: "bold",
            fillColor: [217, 217, 217],
            lineColor: [0, 0, 0],
            textColor: [0, 0, 0],
          },
        },
      ]);
    }
  });

  doc.autoTable({
    margin: { left: config.margin, right: config.margin },
    startY,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 4,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [217, 217, 217],
      textColor: 0,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },
    bodyStyles: {
      halign: "left",
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: 40 },
      1: { cellWidth: boxWidth - 240 },
      2: { cellWidth: 100 },
      3: { cellWidth: 100 },
    },
    didDrawPage: function () {
      drawMarginRect(doc);
      if (letterHead) {
        addHeaderFooter(doc,totalWidth);
      }
    },
  });

  startY = doc.lastAutoTable.finalY 

  // doc.autoTable({
  //   margin: { left: config.margin, right: config.margin },
  //   startY,
  //   body: [
      
  //     [
  //       {
  //         content: "Calibrated By  |",
  //         styles: { fontStyle: "bold", halign: "left" },
  //       },
  //       {
  //         content: "Verified By  |",
  //         styles: { fontStyle: "bold", halign: "left" },
  //       },
  //     ],[
  //     {
  //       content: "Prepared By :                                                        QM",
  //       styles: { fontStyle: "bold", halign: "left" },
  //     },
  //     {
  //       content:
  //         "Approved and Issued By :                                    MD & TM",
  //       styles: { fontStyle: "bold", halign: "left" },
  //     },
  //   ]],
  //   theme: "grid",
  //   styles: {
  //     fontSize: config.fontSize,
  //     cellPadding: 4,
  //     lineWidth: 0.5,
  //     lineColor: [0, 0, 0],
  //     textColor: [0, 0, 0],
  //   },
  //   headStyles: {
  //     fillColor: [217, 217, 217],
  //     textColor: 0,
  //     fontStyle: "bold",
  //     halign: "center",
  //     valign: "middle",
  //   },
  //   bodyStyles: {
  //     halign: "left",
  //     valign: "middle",
  //   },
  //   columnStyles: {
  //     0: { cellWidth: (totalWidth - config?.margin*2) / 2 },
  //     1: { cellWidth: (totalWidth - config?.margin*2) / 2 },
  //   },
  //   didDrawPage: function () {
  //     drawMarginRect(doc);
  //     if (letterHead) {
  //       addHeaderFooter(doc);
  //     }
  //   },
  // });
  
}

function drawMasterReadingTable(
  doc,
  drawMarginRect,
  checkPointData,
  letterHead,
  totalWidth,
  beforeCalibrationData,
  afterCalibrationData,
  instrumentData
) {
  const margin = config.margin * 2;
  const columnWidth = (totalWidth - margin) / 4;
  let startY = config.headerHeight + config.margin + 15;

  const defaultTableStyles = {
    margin: { left: config.margin, right: config.margin },
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      cellPadding: 4,
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [217, 217, 217],
      textColor: 0,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },
    bodyStyles: {
      halign: "left",
      valign: "middle",
    },
    didDrawPage: () => {
      drawMarginRect(doc);
      if (letterHead) addHeaderFooter(doc,totalWidth);
    },
  };

  // Helper to draw a table
  const drawTable = (head, body, columnWidths, additionalHeight = 5) => {
    doc.autoTable({
      ...defaultTableStyles,
      startY,
      head: head ? [head] : undefined,
      body,
      columnStyles: columnWidths.reduce(
        (acc, width, index) => ({
          ...acc,
          [index]: { cellWidth: width },
        }),
        {}
      ),
    });
    startY = doc.lastAutoTable.finalY + additionalHeight;
  };

  // Draw Title
  const drawTitle = (title, colSpan = 4) => {
    drawTable(
      null,
      [
        [
          {
            content: title,
            colSpan,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
        ],
      ],
      Array(colSpan).fill(columnWidth)
    );
  };

  // Draw Master Details
  const drawMasterDetails = () => {
    const data = [
      ["Instruments Name", `${instrumentData?.label}`, "Model", `${instrumentData?.model}`],
      ["Make", `${instrumentData?.make}`, "Id.No", `${instrumentData?.stId}`],
    ];
    drawTable(
      null,
      data.map((row) =>
        row.map((content, index) => ({
          content,
          styles: index % 2 === 0 ? { fontStyle: "bold" } : {},
        }))
      ),
      Array(4).fill(columnWidth)
    );
  };

  // Draw Calibration Data
  const drawCalibrationData = (data,hight=5) => {
    if (!data || data.length === 0) return;

    const tableHead = [
      "Sr.No",
      "STANDARD READINGS",
      "ACTUAL MEASURED READINGS",
      "ERROR",
      "ACCEPTANCE CRITERIA",
    ];

    const tableBody = data.map((item, index) => [
      { content: index + 1, styles: { halign: "center" } },
      { content: item.standardReading, styles: { halign: "center" } },
      { content: item.actualMeasuredReading, styles: { halign: "center" } },
      { content: item.error, styles: { halign: "center" } },
      {
        content: item.acceptanceCriteria,
        styles: { halign: "center" },
        rowSpan: data.length > 1 ? data.length : 1,
      },
    ]);

    drawTable(tableHead, tableBody, [
      40,
      columnWidth - 10,
      columnWidth - 10,
      columnWidth - 10,
      columnWidth - 10,
    ],hight);
  };

  // Draw header and calibration sections dynamically
  drawTitle("CHECK LIST FOR ONSITE CALIBRATION");
  drawTitle("Before Calibration - Master Instruments Functional Verification");
  drawMasterDetails();
  drawCalibrationData(beforeCalibrationData);

  drawTitle("After Calibration - Master Instruments Functional Verification");
  drawCalibrationData(afterCalibrationData,0);

  // Draw Verification Table
  const drawVerificationTable = () => {
    drawTable(
      null,
      [
        [
          {
            content: "Calibrated By",
            styles: { fontStyle: "bold", halign: "center" },
          },
          "",
          {
            content: "Verified By",
            styles: { fontStyle: "bold", halign: "center" },
          },
          "",
        ],
      ],
      [
        90,
        (totalWidth - margin) / 2 - 90,
        90,
        (totalWidth - margin) / 2 - 90,
      ],
      0
    );
  };

  // Draw Footer Table
  const drawFooterTable = () => {
    drawTable(
      null,
      [
        [
          {
            content: "Prepared By :                                                        QM",
            styles: { fontStyle: "bold", halign: "left" },
          },
          {
            content:
              "Approved and Issued By :                                    MD & TM",
            styles: { fontStyle: "bold", halign: "left" },
          },
        ],
      ],
      [(totalWidth - margin) / 2, (totalWidth - margin) / 2],
      0
    );
  };

  // Draw tables
  // drawVerificationTable();
  // drawFooterTable();
}



export function generatePDF1(
  checkPointData,
  standardDetails,
  client,
  addressData,
  beforeCalibrationData,
  afterCalibrationData,
  instrumentData,
  letterHead
) {
  let letterHeads = true;
  config.letterHead = letterHead;
  const doc = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "a4",
    compress: true,
  });
  const totalWidth = doc.internal.pageSize.getWidth();
  const totalHeight = doc.internal.pageSize.getHeight();

  const drawMarginRect = (doc) => {
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.rect(
      config?.borderMagin,
      config?.borderMagin + config?.headerHeight + config.bordergap,
      totalWidth - config?.borderMagin * 2,
      totalHeight -
        config?.borderMagin * 2 -
        (config?.headerHeight + config?.footerHeight + 45) -
        config.bordergap
    );
  };

  drawCheckListTable(
    doc,
    drawMarginRect,
    checkPointData,
    letterHeads,
    standardDetails,
    client,
    addressData,
    totalWidth
  );
  doc.addPage();
  drawMasterReadingTable(
    doc,
    drawMarginRect,
    checkPointData,
    letterHeads,
    totalWidth,
    beforeCalibrationData,
    afterCalibrationData,
    instrumentData
  );

  const totalPages = doc.getNumberOfPages();
  for (let page = 1; page <= totalPages; page++) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(config.fontSize);
    doc.setTextColor(0);
    doc.setPage(page);
    let content = `Page No : ${String(page).padStart(2, "0")} of ${String(
      totalPages
    ).padStart(2, "0")}`;
    doc.text(
      content,
      doc.internal.pageSize.getWidth() - config.margin - 75 - config.borderMagin ,
      config?.headerHeight + config?.margin - 7,
      { align: "left" }
    );
  }

  // In case there are pages that didn't trigger didDrawPage, loop through all pages to add header/footer
  // if (letterHeads) {
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addHeaderFooter(doc,totalWidth);
      drawMarginRect(doc,totalWidth);
    }
  // }

  doc.save("CheckPoint.pdf");
}
